module.exports = __webpack_public_path__ + "img/chile.f2072c7c.svg";